import {
  DRUPAL_NODE_DISPLAY,
  type DrupalImage,
  type DrupalNodePage,
  type DrupalTerm,
} from '@commons/types/drupal';

import PodcastNodeCard from './Card';
import PodcastNodeFeatured from './Featured';
import PodcastNodeFeaturedTile from './FeaturedTile';
import PodcastNodeLabel from './Label';
import PodcastNodeSmallCard from './SmallCard';
import PodcastNodeTeaser from './Teaser';

/**
 * Type definition of a Podcast node properties.
 */

export type PodcastNodeProps = DrupalNodePage & {
  date: string;
  image?: DrupalImage;
  format?: DrupalTerm;
  authors?: string;
  summary?: string;
};

/**
 * Podcast node component.
 *
 * Renders a component based on the display type.
 */

export const PodcastNode = (props: PodcastNodeProps) => {
  switch (props.display) {
    default:
    case DRUPAL_NODE_DISPLAY.Default:
    case DRUPAL_NODE_DISPLAY.Label:
      return <PodcastNodeLabel {...props} />;
    case DRUPAL_NODE_DISPLAY.Teaser:
      return <PodcastNodeTeaser {...props} />;
    case DRUPAL_NODE_DISPLAY.Card:
      return <PodcastNodeCard {...props} />;
    case DRUPAL_NODE_DISPLAY.SmallCard:
      return <PodcastNodeSmallCard {...props} />;
    case DRUPAL_NODE_DISPLAY.Featured:
      return <PodcastNodeFeatured {...props} />;
    case DRUPAL_NODE_DISPLAY.FeaturedTile:
      return <PodcastNodeFeaturedTile {...props} />;
  }
};

export default PodcastNode;
